import React from 'react'
import Navbar from '../../components/navbar/Navbar'
import Header from '../../components/header/Header'
import "./list.css";
import { useState } from "react";
import { DateRange } from 'react-date-range'
import SearchItem from '../../components/searchitem/SearchItem'
import { useLocation } from 'react-router-dom';
import { format } from 'date-fns';
const List = () => {
  const location = useLocation();
  const destination = location.state ? location.state.destination : '';
  const date = location.state ? location.state.date : [{ startDate: new Date(), endDate: new Date() }];
  const options = location.state ? location.state.options : { adult: 1, children: 0, room: 1 };

  const [openDate, setOpenDate] = useState(false);
  const [selectedDate, setSelectedDate] = useState(date);

  return (
  <div>
      <Navbar/>
    <Header type="list"/>
    <div className="listContainer">
      <div className="listWrapper">
         <div className="listSearch">
           <h1 className="lsTitle">Search</h1>
           <div className="lsItem">
            <label >Destination</label>
            <input type="text" placeholder={destination}/>
           </div>
           <div className="lsItem">
           <label>Check-in Date</label>
           <span onClick={() => setOpenDate(!openDate)}>
                {`${format(date[0].startDate, "MM/dd/yyyy")} to ${format(date[0].endDate, "MM/dd/yyyy")}`}
              </span>


              {openDate && (
                <DateRange
                  onChange={(item) => setSelectedDate([item.selection])}
                  minDate={new Date()}
                  range={selectedDate}
                />
                )}
           </div>
           <div className="lsItem">
            <label >Options</label>
            <div className="lsOptions">
            <div className="lsOptionsItem">
              <span className="lsOptionText">
                Min Price <small>per night</small>
                </span>
                <input type="number" className="lsOptionInput" />
            </div>
            <div className="lsOptionsItem">
              <span className="lsOptionText">
                Max Price <small>per night</small>
                </span>
                <input type="number" className="lsOptionInput" />
            </div>
            <div className="lsOptionsItem">
              <span className="lsOptionText">
                Adult 
                </span>
                <input type="number" min={1} className="lsOptionInput" placeholder={options.adult} />
            </div>
            <div className="lsOptionsItem">
              <span className="lsOptionText">
                Children
                </span>
                <input type="number" min={0}
              className="lsOptionInput" placeholder={options.children} />
            </div>
            <div className="lsOptionsItem">
              <span className="lsOptionText">
               Room
                </span>
                <input type="number" min={1} className="lsOptionInput" placeholder={options.room}/>
            </div>
           </div>
         </div>
         <button>Search</button>
         </div>
        <div className="listResult">
          <SearchItem/>
          <SearchItem/>
          <SearchItem/>
          <SearchItem/>
          <SearchItem/>
          <SearchItem/>
          <SearchItem/>
          <SearchItem/>
        </div>
      </div>
    </div>
  </div>
  )
}

export default List;
